export const getImgWidthHeight = url => {
  return new Promise((resolve, reject) => {
    console.log('进来了',url);
    let canvas = document.createElement('CANVAS')
    let ctx = canvas.getContext('2d')
    let img = new Image()
    img.crossOrigin = 'Anonymous'
    img.onload = function () {
      canvas.height = img.height
      canvas.width = img.width
      ctx.drawImage(img, 0, 0)
      console.log(img.width,img.height,'高宽');
      resolve({ width: canvas.width, height: canvas.height })
      canvas = null
    }
    img.onerror = function (error) {
      reject(error)
    }
    img.src = url
  })
}

// url 转 base64
function urlToBase64(url) {
  return new Promise(resolve => {
    fetch(url)
      .then(data => {
        const blob = data.blob()
        return blob
      })
      .then(blob => {
        let reader = new FileReader()
        reader.onloadend = function () {
          const dataURL = reader.result
          console.log('base64地址：', dataURL)
          resolve(dataURL)
        }
        reader.readAsDataURL(blob)
      })
  })
}

//   获取video 文件大小
export const getVideoSize = url => {
  return new Promise((resolve, reject) => {
    fetch(url)
      .then(data => {
        const blob = data.blob()
        return blob
      })
      .then(blob => {
        let reader = new FileReader()
        reader.onloadend = function () {
          const dataURL = reader.result
          console.log('base64地址：', dataURL)
          let file = dataURLtoFile(dataURL)
          console.log(file)
          resolve(`${(file.size / 1024 / 1024).toFixed(2)}m`)
        }
        reader.readAsDataURL(blob)
      })
      .catch(res => {
        reject('获取文件大小失败')
      })
  })
}
//   base64 转file
export const dataURLtoFile = (dataurl, filename = 'test') => {
  // 获取到base64编码
  const arr = dataurl.split(',')
  // 将base64编码转为字符串
  const bstr = window.atob(arr[1])
  let n = bstr.length
  const u8arr = new Uint8Array(n) // 创建初始化为0的，包含length个元素的无符号整型数组
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new File([u8arr], filename, {
    type: 'image/jpeg'
  })
}
